import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import { defineComponent, ref, computed, openBlock, createBlock, unref, normalizeClass, withCtx, renderSlot, normalizeProps, guardReactiveProps, createVNode, createElementVNode, createElementBlock, Fragment, renderList, withModifiers, Transition, createCommentVNode, toDisplayString } from 'vue';
import { useStyleConfig } from '../abstract';
import { Tabs, TabPane } from 'ant-design-vue';
import { DatabaseFilled, LockFilled, UnlockFilled, SyncOutlined, CloseOutlined } from '@ant-design/icons-vue';
var _hoisted_1 = ["onContextmenu"];
var _hoisted_2 = ["onClick"];
var _hoisted_3 = ["onClick"];
var _sfc_main = /*#__PURE__*/defineComponent({
  __name: 'TabsViewHead',
  props: {
    tabList: Array,
    useCache: Boolean,
    active: [String, Number],
    lock: Boolean
  },
  emits: ["refresh", "close", "change", "contextmenu", "update:lock"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useStyleConfig = useStyleConfig('tabs-view-head'),
      prefixCls = _useStyleConfig.prefixCls;
    var focus = ref();
    var activeTab = computed(function () {
      return props.tabList.find(function (item) {
        return item.key === props.active;
      });
    });
    function onChange(active) {
      var activeItem = props.tabList.find(function (item) {
        return item.key === active;
      });
      emit('change', activeItem);
    }
    return function (_ctx, _cache) {
      return openBlock(), createBlock(unref(Tabs), {
        type: "card",
        "active-key": __props.active,
        class: normalizeClass(unref(prefixCls)),
        onChange: onChange
      }, {
        rightExtra: withCtx(function () {
          var _activeTab$value;
          return [renderSlot(_ctx.$slots, "cacheIcon", normalizeProps(guardReactiveProps({
            cached: __props.useCache && ((_activeTab$value = activeTab.value) === null || _activeTab$value === void 0 ? void 0 : _activeTab$value.cacheable)
          })), function () {
            var _activeTab$value2;
            return [createVNode(unref(DatabaseFilled), {
              class: normalizeClass(["".concat(unref(prefixCls), "-cache"), {
                enable: __props.useCache && ((_activeTab$value2 = activeTab.value) === null || _activeTab$value2 === void 0 ? void 0 : _activeTab$value2.cacheable)
              }])
            }, null, 8 /* PROPS */, ["class"])];
          }), createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return emit('update:lock', !__props.lock);
            }),
            class: normalizeClass("".concat(unref(prefixCls), "-lock-icon"))
          }, [renderSlot(_ctx.$slots, "lockIcon", normalizeProps(guardReactiveProps({
            locked: __props.lock
          })), function () {
            return [__props.lock ? (openBlock(), createBlock(unref(LockFilled), {
              key: 0,
              class: normalizeClass("".concat(unref(prefixCls), "-lock"))
            }, null, 8 /* PROPS */, ["class"])) : (openBlock(), createBlock(unref(UnlockFilled), {
              key: 1,
              class: normalizeClass("".concat(unref(prefixCls), "-unlock"))
            }, null, 8 /* PROPS */, ["class"]))];
          })], 2 /* CLASS */)];
        }),

        default: withCtx(function () {
          return [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.tabList, function (item) {
            return openBlock(), createBlock(unref(TabPane), {
              class: normalizeClass("".concat(unref(prefixCls), "-pane")),
              key: item.key
            }, {
              tab: withCtx(function () {
                return [createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-tab")),
                  onContextmenu: withModifiers(function ($event) {
                    return emit('contextmenu', item);
                  }, ["prevent"])
                }, [createVNode(Transition, {
                  name: "size"
                }, {
                  default: withCtx(function () {
                    return [__props.active === item.key || focus.value === item.key || item.loading ? (openBlock(), createElementBlock("div", {
                      key: 0,
                      onClick: withModifiers(function ($event) {
                        return emit('refresh', item);
                      }, ["stop"]),
                      class: normalizeClass(["".concat(unref(prefixCls), "-icon"), 'refresh', "".concat(unref(prefixCls), "-item")])
                    }, [renderSlot(_ctx.$slots, "refreshIcon", normalizeProps(guardReactiveProps({
                      tab: item
                    })), function () {
                      return [createVNode(unref(SyncOutlined), {
                        spin: item.loading
                      }, null, 8 /* PROPS */, ["spin"])];
                    })], 10 /* CLASS, PROPS */, _hoisted_2)) : createCommentVNode("v-if", true)];
                  }),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */), createElementVNode("span", {
                  class: normalizeClass(["".concat(unref(prefixCls), "-title"), "".concat(unref(prefixCls), "-item"), {
                    deactvie: __props.active !== item.key && focus.value !== item.key
                  }])
                }, toDisplayString(item.title), 3 /* TEXT, CLASS */), item.closeable ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  onClick: withModifiers(function ($event) {
                    return emit('close', item);
                  }, ["stop"]),
                  class: normalizeClass(["".concat(unref(prefixCls), "-icon ").concat(unref(prefixCls), "-item"), 'close'])
                }, [renderSlot(_ctx.$slots, "closeIcon", normalizeProps(guardReactiveProps({
                  tab: item
                })), function () {
                  return [createVNode(unref(CloseOutlined))];
                })], 10 /* CLASS, PROPS */, _hoisted_3)) : createCommentVNode("v-if", true)], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"]);
          }), 128 /* KEYED_FRAGMENT */))];
        }),

        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["active-key", "class"]);
    };
  }
});
var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var TabsViewHead = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/tabs-view/TabsViewHead.js"]]);
export { TabsViewHead as default };